
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface CollectionSummaryItem {
  id: number;
  date: string;
  zone: string;
  collector: string;
  totalAmount: number;
  transactions: number;
  method: string;
}

interface CollectionSummaryTableProps {
  data: CollectionSummaryItem[];
}

const CollectionSummaryTable = ({ data }: CollectionSummaryTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Date</TableHead>
          <TableHead>Zone</TableHead>
          <TableHead>Collector</TableHead>
          <TableHead className="text-right">Amount</TableHead>
          <TableHead className="text-center">Transactions</TableHead>
          <TableHead>Method</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((item) => (
          <TableRow key={item.id}>
            <TableCell>{item.date}</TableCell>
            <TableCell>{item.zone}</TableCell>
            <TableCell>{item.collector}</TableCell>
            <TableCell className="text-right">
              ${item.totalAmount.toLocaleString()}
            </TableCell>
            <TableCell className="text-center">{item.transactions}</TableCell>
            <TableCell>{item.method}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CollectionSummaryTable;
